<template>
  <el-card>
    <div slot="header" class="font-weight-bold d-flex justify-content-between">
      <div v-if="checkoutType === 'CartRequest'">
        {{ $t('general.recent_cart_requests') }}
      </div>
      <div v-else>
        {{ $t('general.recent_cart_orders') }}
      </div>
      <el-link type="primary" @click="onMore">
        {{ $t('general.more') }}
      </el-link>
    </div>
    <div>
      <table class="el-table el-table--striped el-tab">
        <thead>
          <tr>
            <th>Status</th>
            <th>{{ $t('general.created_at') }}</th>
            <th>{{ $tc('systems.system', 2) }}</th>
            <th>{{ $tc('products.product', 2) }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="request in requests" :key="request.id" class="cursor-pointer" @click="onSelect(request)">
            <td>
              <StatusTag :status="request.get('status')" />
            </td>
            <td>{{ request.get('createdAt').toLocaleDateString() }}</td>
            <td>{{ request.get('systems').length }}</td>
            <td>{{ request.get('products').length }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </el-card>
</template>

<script>
import StatusTag from '../../../components/atoms/StatusTag';
export default {
  name: 'RecentCartOrderRequestsCard',
  components: { StatusTag },
  props: {
    checkoutType: {
      type: String,
      default: 'CartRequest',
    },
  },
  async mounted() {
    let query = new this.$parse.Query(this.checkoutType);
    query.equalTo('user', this.$parse.User.current());
    query.limit(4);
    query.find().then((result) => {
      this.requests = result;
    });
  },
  destroyed() {},
  data() {
    return {
      requests: [],
    };
  },
  computed: {
    routeName() {
      return this.checkoutType === 'CartRequest'
        ? this.$routeNames.REQUEST_DETAIL_PAGE_ROUTE
        : this.$routeNames.ORDER_DETAIL_PAGE_ROUTE;
    },
  },
  methods: {
    onMore() {
      this.$router.push({
        name: this.$routeNames.ALL_CART_ORDERSREQUESTS_PAGE_ROUTE,
        params: { checkoutType: this.checkoutType },
      });
    },
    onSelect(item) {
      this.$router.push({ name: this.routeName, params: { id: item.id } });
    },
  },
};
</script>

<style scoped></style>
